interface ContentProgressBarProps {
  currentStep: number;
}

const steps = [
  { number: 1, label: 'Channel Setup' },
  { number: 2, label: 'Brand Communication' },
  { number: 3, label: 'Content Planning' },
];

export default function ContentProgressBar({ currentStep }: ContentProgressBarProps) {
  return (
    <div className="max-w-3xl mx-auto px-6 mb-10">
      <div className="flex items-center justify-between relative">
        {/* Progress Line */}
        <div className="absolute top-4 left-0 right-0 h-0.5 bg-gray-200 z-0"></div>
        <div
          className="absolute top-4 left-0 h-0.5 bg-teal-500 z-0 transition-all duration-500"
          style={{ width: `${((currentStep - 1) / 2) * 100}%` }}
        ></div>

        {steps.map((step) => (
          <div key={step.number} className="flex flex-col items-center relative z-10">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium transition-all duration-300 ${step.number < currentStep
                  ? 'bg-teal-500 text-white'
                  : step.number === currentStep
                    ? 'bg-teal-600 text-white ring-4 ring-teal-100'
                    : 'bg-white border-2 border-gray-200 text-gray-400'
                }`}
            >
              {step.number < currentStep ? (
                <i className="ri-check-line"></i>
              ) : (
                step.number
              )}
            </div>
            <span
              className={`text-xs mt-2 whitespace-nowrap ${step.number === currentStep ? 'text-teal-700 font-semibold' : 'text-gray-400'
                }`}
            >
              {step.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}